import { useMatches } from '@remix-run/react'
import HeaderDesktop from './HeaderDesktop'
import HeaderMobile from './HeaderMobile'

type Props = {
  isSticky?: boolean
  showBanner?: boolean
}

export default function Header({ isSticky, showBanner }: Props) {
  const matches = useMatches()
  const pathName = matches[matches.length - 1]?.pathname
  const currentPath =
    pathName && pathName.endsWith('/') && pathName !== '/'
      ? pathName.slice(0, -1)
      : pathName
  const isHome = currentPath === '/'
  const isActive = (item: { path: string }) => {
    return currentPath === item.path
  }

  return (
    <>
      <div
        className={`
          hidden

          lg:block
        `}
      >
        {showBanner && (
          <HeaderDesktop
            isActive={isActive}
            showBanner={true}
            mode="banner"
            isHome={isHome}
          />
        )}
      </div>
      <div
        className={`
          hidden

          ${isSticky ? `sticky top-0 z-[10000]` : ''}

          lg:block
        `}
      >
        <HeaderDesktop
          isActive={isActive}
          isSticky={false}
          showBanner={false}
          mode="main"
          isHome={isHome}
        />
      </div>
      <div className="lg:hidden">
        {showBanner && (
          <HeaderMobile
            isActive={isActive}
            showBanner={true}
            mode="banner"
            isHome={isHome}
          />
        )}
      </div>
      <div
        className={`
          ${isSticky ? `sticky top-0 z-[100]` : ''}

          lg:hidden
        `}
      >
        <HeaderMobile
          isActive={isActive}
          isSticky={false}
          showBanner={false}
          mode="main"
          isHome={isHome}
        />
      </div>
    </>
  )
}
